<template>
    <button @click="changeInput(modelValue - 1)">-</button>
    <input
            ref="inputRef"
            :type="props.type"
            :class="props.inputClass"
            :name="props.name"
            :value="modelValue"
            :placeholder="props.placeholder"
            @input="changeInput($event.target.value)"
            :max="props.type === 'number' ? props.max : ''"
            :min="props.type === 'number' ? props.min : ''"
    />
    <button @click="changeInput(modelValue + 1)">+</button>
</template>

<script setup>

import {ref} from 'vue';

const props = defineProps({
    type: {
        type: String,
        default: 'text'
    },
    inputClass: {
        type: String,
        default: 'count-input'
    },
    placeholder: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        default: ''
    },
    modelValue: {
        type: [String, Number],
        default: ''
    },
    max: {
        type: Number,
        default: null
    },
    min: {
        type: Number,
        default: null
    },
})

const emit = defineEmits(['update:modelValue'])
const inputRef = ref(null)

const changeInput = (value) => {
    if (!/^\d*[1-9]\d*$/.test(value)) {
        value = value.slice(0, -1);
        inputRef.value.value = value;
    }
    if (props.min !== null && value < props.min) {
        value = props.min;
        inputRef.value.value = value;
    } else if (props.max !== null && value > props.max) {
        value = props.max;
        inputRef.value.value = value;
    }

    emit('update:modelValue', value);
}

</script>
